module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAABZklEQVRIS72Wv07CUBTGv4MmIsZBI4Ojf6KJk4Oz0IUg8Q2Mxt3XcNAH4QWMLu6G0cnJgWegDVAg8pnTAKnS25xW5Cbdvvvrd869PV8Ff1wki91ut0LyQh/JwwvDcH80GkUAkp6IlKYcE7DdbhfL5fI5yQaAOsljlxEnsN/v7w2Hw4aI1AF4ADYs1cyAJNc6nU6lUCgoQJ04XaSBxff9IwAPAGpWF6nAIAjeSZ5ayrFo1OEYgOlwrEBahFaNOpwDbj5fmfYHl8053XKAJnsOUaJD1a58PmG8cwJuHWbiJwIVtv5yi971W3T8pdZ9ItTcw9WPJoqvd+jdtBYDVDsK/do9A7ezfYHOHmZqXEy8nGuz8Iudt1zdt/jh8B/jSwfsI8laPGzylv0jAnzfr2oETMJIX5R5OQerRuVgMIhCSkQ8krOoTI0Ai4XfYQ7A6T7X6A/D8GAa9CJSjbvPBYxXNXGv0OhP4hsDAd0eIuOh0AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_close.png
// module id = ShLw
// module chunks = 14